import { INITIALIZATION_SET, VERSION_SET } from '../../reducers/global-ab-test';
import analytics, { DataLayerProps } from '../../services/analytics';
import store from '../../store';
import serializeQueryParams from '../url/serialize-query-params';
import { ACTIVATION_EVENT, EXPERIMENT_ID } from './global-ab-test.constants';

const gtag = function () {
    analytics.push(arguments as DataLayerProps);
};

const setVersion = (version: string) => {
    if (version) {
        // @ts-ignore
        store.dispatch({ data: { version }, type: VERSION_SET });
    }

    console.info(version);
};

const initGlobalABTest = (event = ACTIVATION_EVENT, param = 'globalVersion') => {
    const { initialized } = store.getState().globalABTest as ABTest;
    const params = serializeQueryParams();

    if (params[param]) {
        setVersion(params[param] as string);

        return;
    }

    if (initialized) {
        return;
    }

    window.startGlobalAB = (version: string) => {
        setVersion(version);
    };

    // @ts-ignore
    gtag('event', 'optimize.callback', {
        callback: setVersion,
        name: EXPERIMENT_ID
    });

    // @ts-ignore
    analytics.push({ event });
    // @ts-ignore
    store.dispatch({ type: INITIALIZATION_SET });
};

export default initGlobalABTest;
